import moment from "moment";

class DateUtils {
    getCurrentTh(format = 'DD/MM/YYYY') {
        return moment.utc().add(7, 'hours').format(format);
    }

    getDateTh(date, format = 'DD/MM/YYYY') {
        return moment.utc(date).add(7, 'hours').format(format);
    }

    // getCurrentPlusOneTh(format = 'DD/MM/YYYY') {
    //     return moment.utc().add(1, 'days').add(7, 'hours').format(format);
    // }
    getCurrentPlusOneTh(date, format = 'DD/MM/YYYY') {
        return date ? 
                    moment.utc(date).add(1, 'days').add(7, 'hours').format(format) :
                    moment.utc().add(1, 'days').add(7, 'hours').format(format);
    }
}
export default new DateUtils();